import styles from './ConversionProgressBar.module.css';
import type { ConversionProgress } from '../../hooks/useConversionProgress';

const ConversionProgressBar = ({ progress }: { progress: ConversionProgress }) => {
  const pct = Math.min(100, Math.max(0, Math.round(progress.pct)));
  return (
    <div className={styles.wrap}>
      <div className={styles.track}>
        <div className={styles.fill} style={{ width: `${pct}%` }} />
      </div>
      <span className={styles.label} title={progress.stage}>
        {pct}%
      </span>
    </div>
  );
};

export default ConversionProgressBar;
